var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 138,
    viewBox: "0 0 202 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.079 115.161C163.054 93.7927 164.178 61.026 124.512 24.2797C118.759 18.9375 115.948 11.4974 110.238 7.49622C92.9351 -4.63719 68.6467 -2.17158 53.3555 15.8447C44.9854 25.7072 41.6114 39.2464 32.9169 48.9142C23.1626 59.7716 11.4834 70.3261 7.04958 85.1198C4.10815 94.9174 4.60559 105.602 7.95796 115.183C56.1456 123.748 101.695 126.386 141.079 115.161Z",
    fill: "#E7FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.614 57L87.9264 110.688C87.7481 110.866 87.4649 110.884 87.2658 110.729L73.6143 100.111L59.6143 109L57.6143 85.5L39.0445 70.7394C38.6979 70.4639 38.854 69.9071 39.2933 69.8519L141.614 57Z",
    fill: "#028383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6143 109L65.1143 93.5M59.6143 109L57.6143 85.5M59.6143 109L73.6143 100.111M65.1143 93.5L141.614 57M65.1143 93.5L73.6143 100.111M141.614 57L87.9264 110.688C87.7481 110.866 87.4649 110.884 87.2658 110.729L73.6143 100.111M141.614 57L39.2933 69.8519C38.854 69.9071 38.6979 70.4639 39.0445 70.7394L57.6143 85.5M141.614 57L57.6143 85.5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6149 107.5C-6.88572 114 -47.9643 136 126.615 136C192.614 136 241.5 117 148.5 107.5",
    stroke: "#616161",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPost);
export default __webpack_public_path__ + "static/media/NoPost.05704099005d74422872ebbda0ccef04.svg";
export { ForwardRef as ReactComponent };